import _ from 'lodash'
import EventBus from '@/eventBus'
import Constants from '@/constant'
import mixpanelUtils from '@/utils/mixpanel.utils'
import {
  SET_CURRENT_SLIDE_MODE,
  WINDOWED_MODE,
  EDIT_MODE,
  SET_CURRENT_ACTIVE_SLIDE,
} from '@/vuex/types'

import Socket from '@/socket'
import socketHelper from '@/helpers/socket/socket-helper'
import CollabHelpler from '@/helpers/collab/collab-helper'
import store from '@/vuex/store'

// configs
import Config from '@/config'

import storage from '@/services/storage'

// utils
import Utils from '@/util'
import SlideApi from '@/api/slide'
import RenderCanvasUtil from '@/utils/renderCanvasBlocksUtils'
import workspace from '@/constant/workspace'

const CREATE_REACTION = 'create-reaction'

export default {
  initSocket(channel, editor) {
    Socket.subscribe(`${channel}-presenter`, (doc) => {
      this.initSocketHandler(doc, editor)
    })
  },

  initSocketHandler(doc, editor) {
    if (doc.socketId == Socket.getSocketId()) {
      return
    }

    if (doc.t === 'account-removal') {
      window.location.href = Config.accountRemovalURL
      return
    }

    if (doc.type == 'uO') {
      this._handleUserOnlineCount(editor, doc)
      return
    }

    let index
    const { presentation } = editor.$store.state

    // handle socket msg answer quiz, poll from audience
    if (doc.t == 'a') {
      editor._checkAndUpdateHasResults()
      let indexSlideVote = null

      if (doc.s != editor.slideActive.id) {
        const indexSlideInPresentation = editor.presentation.slides.findIndex((item) => {
          return item.id == doc.s
        })

        if (indexSlideInPresentation !== -1) {
          indexSlideVote = indexSlideInPresentation
        }
      }

      if (doc.iTa) {
        if (!editor.slideActive.multipleCountAnswer) {
          editor.updateSlideActiveAction({
            multipleCountAnswer: 0,
          })
          editor.$store.state.tempAudienceCount = 0
        }

        if (indexSlideVote === null) {
          editor.$store.state.tempAudienceCount++
          this.updateVoteCountThrottle(editor, doc, null)
        } else {
          editor.$store.state.presentation.slides[indexSlideVote].voteCache++
          this.updateVoteCountThrottle(editor, doc, indexSlideVote)
        }

        if (!editor.sharePresentation && editor.slideActive.type == 'pickAnswer') {
          if (editor.userOnline < 30) {
            if (editor.$store.state.audiences[doc.a]) {
              editor.$store.state.audiences[doc.a][doc.s] = true
              this._checkEveryoneVotedQuiz(editor)
            }
          }
        }
        return
      }

      if (doc.v && doc.v.length) {
        if (!editor.slideActive.multipleCountAnswer) {
          editor.updateSlideActiveAction({
            multipleCountAnswer: 0,
          })
          editor.$store.state.tempAudienceCount = 0
        }

        if (indexSlideVote === null) {
          editor.$store.state.tempAudienceCount++
          this.updateVoteCountThrottle(editor, doc, null)
        } else {
          editor.$store.state.presentation.slides[indexSlideVote].voteCache++

          this.updateVoteCountThrottle(editor, doc, indexSlideVote)
        }

        this._updateSlideOptions(editor, doc)
        if (editor.presentation.audiencePacing) {
          // update chart whenever audience answers
          editor.$store.dispatch('updateSlideActive', editor.slideActive)
        }

        if (!editor.sharePresentation && editor.slideActive.type == 'pickAnswer') {
          if (editor.userOnline < 30) {
            if (editor.$store.state.audiences[doc.a]) {
              editor.$store.state.audiences[doc.a][doc.s] = true
              this._checkEveryoneVotedQuiz(editor)
            }
          }
        }
      }

      return
    }

    if (doc.type == 'question-and-answer') {
      if (doc.action == 'create') {
        editor._checkAndUpdateHasResults()
        if (!editor.presentation.isModerationMode) {
          const arr = JSON.parse(JSON.stringify(editor.$store.state.questions))
          arr.push(doc.data)
          Utils.updateDataQuestionAnswer(arr, editor.$store.state.tabQnaQuestion)
          EventBus.$emit('questionAnimationAction')
        } else {
          editor.$store.state.questions.push(doc.data)
        }
        Utils.gaTrackEvent('Question And Answer', 'Question Received', 'Question Received')
      } else if (doc.action == 'vote' || doc.action === 'question-updated') {
        this._updateQuestionAnswer(editor, doc.data)
      }
    }

    // using both channel
    if (doc.type == 'slide' && doc.data.id == editor.slideActive.id) {
      const { data } = doc

      const payload = {
        type: doc.type,
        layout: doc.layout,
        multipleChoice: data.multipleChoice,
        limitChoice: data.limitChoice,
        typeChart: data.typeChart || 'barChart',
        hideResult: data.hideResult,
        addCorrectOption: data.addCorrectOption,
        stopSubmission: data.stopSubmission,
        showAllBulletPoints: data.showAllBulletPoints,
        image: data.image,
        imageCaption: data.imageCaption,
        youtubeLink: data.youtubeLink,
        backgroundImage: data.backgroundImage,
        textColour: data.textColour,
        baseColour: data.baseColour,
        visibility: data.visibility,
        showQuestionImage: data.showQuestionImage,
      }

      if (!editor.sharePresentation) {
        payload.showCorrectOption = doc.data.showCorrectOption
      }

      editor.updateSlideActive(payload)
    }

    if (doc.type == 'presentation') {
      if (
        doc.action == 'nextSlide' &&
            !editor.sharePresentation &&
            !editor.$store.state.isDisableEditPresentation
      ) {
        if (!store.getters.isPresenting &&
          (store.state.presentation.accountId || store.state.presentation.hasSharedUser)) {
          return
        }
        if (doc.data.id == editor.slideActive.id) return
        const index = editor.presentation.slides.findIndex(
          (item) => {
            return item.id == doc.data.id
          },
        )
        editor.$store.dispatch('checkSlideMovingDirectionAction', doc.data.id)
        editor.$store.dispatch('updateSlideActive', {
          activeTab: null,
          id: null,
        })
        setTimeout(() => {
          editor.$store.dispatch(
            'setSlideActive',
            editor.presentation.slides[index],
          )

          EventBus.$emit('eventHandleSetValueTransition')
        }, 0)
      }

      if (doc.action == 'uniqueAccessCode') {
        editor.$store.state.presentation.qrcode = doc.data.qrcode
        editor.$store.state.presentation.uniqueAccessCode =
              doc.data.uniqueAccessCode
        editor.$store.state.presentation.shareCode = doc.data.shareCode
      }

      if (doc.action == 'changeAccessCode') {
        editor.$store.state.presentation.accessCode = doc.data.accessCode
      }

      if (doc.action == 'presenting') {
        // (Collab)Khi take-over present thì các user còn lại sẽ chuyển thành viewer
        CollabHelpler.getListUsersEditPresentation()
      }

      const isMSTeamInParam = !!Utils.getParamValue(
        'ms-teams',
        window.location.href,
      )

      if (doc.action == 'presenting' && !editor.sharePresentation) {
        if (editor.$store.state.isPreview || doc.data.presentFromPPT) return

        editor.$store.state.presentation.presenting = doc.data.presentation.presenting

        // sửa thành tất cả các tabs present cùng nhau
        // để có thể khắc phục tình trạng 1 máy đang present
        // nhưng 1 tab khác edit thì màn hình đang present sẽ không được update
        // theo và nhảy lung tung mà don't know why.
        if (!editor.$store.state.isDisableEditPresentation) {
          if (doc.data.presentation.presenting) {
            editor.$store.dispatch(SET_CURRENT_SLIDE_MODE, WINDOWED_MODE)
          } else if (isMSTeamInParam) {
            // Khi đang edit bên AhaSlides tab thì cần alert user cần reload để lấy bản mới nhất cho bên MS Teams tab.
            // Do không phải cái gì cũng realtime update sang bên MS Teams tab.
            editor.isShowMSTeamsReloadModal = true
          } else {
            editor.$store.dispatch(SET_CURRENT_SLIDE_MODE, EDIT_MODE)
          }
        }
      }

      if (doc.action == 'privateMode') {
        editor.$store.state.presentation.privateMode = doc.data.presentation.privateMode
      }

      if (doc.action === 'presentation-update' && doc.socketId !== Socket.getSocketId()) {
        const newPayload = {}
        Object.keys(doc.data).forEach((key) => {
          const oldValue = doc.data[key]
          let newValue = oldValue
          if (typeof oldValue === 'string') {
            if (oldValue === 'true') {
              newValue = true
            }
            if (oldValue === 'false') {
              newValue = false
            }
          }
          newPayload[key] = newValue
        })
        editor.$store.dispatch('updatePresentation', newPayload)
      }
    }

    if (doc.type === 'user-online-count') {
      if (doc.data || doc.data === 0) {
        if (doc.data > editor.userOnline) {
          EventBus.$emit('userOnlineCount')
          if (editor.isPresenting && !editor.sharePresentation) {
            editor.updatePresentationSessionOnlineCount(editor.presentation.id, doc.data)
          }
        }

        editor.onlineCount = doc.data
        this._handleOnlineCountThrottled(editor)
        if (!editor.maxOnlineCount || editor.onlineCount > editor.maxOnlineCount) {
          editor.maxOnlineCount = editor.onlineCount
        }
      }

      if (doc.off) {
        if (editor.$store.state.audiences[doc.off]) {
          editor.$store.state.audiences[doc.off].offline = true
          const offlineAudience = editor.$store.state.audiences[doc.off]
          if (editor.presentation.teamPlay) {
            editor._getAndSetPayloadAudienceTeamName(offlineAudience)
          }
          editor.audienceChangeStatusAction(offlineAudience)
        }

        if (editor.userOnline < 60 && editor.slideActive.type == 'pickAnswer'
              && editor.slideActive.quizStatus == Constants.QuizStatuses.LOBBY_SCREEN) {
          editor._getAudienceOnlineJoinQuiz()
        }
      }
    }

    if (doc.type == 'slideOption' && doc.action == 'audience-create') {
      editor._checkAndUpdateHasResults()
      if (editor.slideActive.type === 'openEnded') {
        if (editor.slideActive.id === doc.data.slideId) {
          EventBus.$emit('new-opended', doc.data)
        }

        return
      }

      const matchSlide = editor.presentation.slides.find((slide) => slide.id === doc.data.slideId)
      if (!matchSlide) return

      const newSlideOptions = [...matchSlide.SlideOptions, doc.data]
      editor.patchSlideByIdAction({
        id: doc.data.slideId,
        SlideOptions: newSlideOptions,
      })
    }

    if (
      doc.type == 'slideWordCloud' &&
          doc.action == 'audience-wordcloud'
    ) {
      editor._checkAndUpdateHasResults()
      if (doc.data.slideId == editor.slideActive.id) {
        const newSlideOptions = editor.slideActive.SlideOptions.concat(doc.data.options)
        editor.updateSlideActiveAction({
          SlideOptions: newSlideOptions,
        })

        EventBus.$emit('audienceWordCloud')
      } else {
        index = Utils.getIndexSlide(presentation.slides, doc.data.slideId)
        if (index != -1) {
          presentation.slides[index].SlideOptions = presentation.slides[
            index
          ].SlideOptions.concat(doc.data.options)
        }
      }
    }

    if (doc.type == 'active-one-time') {
      editor.$store.state.currentUser.oneTimeEnd = doc.data
      return
    }

    if (doc.type == 'export-status') {
      editor.$store.dispatch('updatePresentation', { exportData: doc.exportData })
      return
    }

    if (doc.type === 'quiz-show-answer' && editor.sharePresentation) {
      if (editor.slideActive.id === parseInt(doc.data.slideId, 10)) {
        EventBus.$emit('eventShowQuizTypeAnswer')
      }
      return
    }

    if (doc.type === 'aLQT') {
      this._handleChangeQuizTeam(editor, doc.data)
      EventBus.$emit('gamelobby-leave-team', doc.data)
      editor._setTeamData()
    }

    if (doc.t === 'sca') {
      editor._checkAndUpdateHasResults()
      if (!editor.slideActive.multipleCountAnswer) {
        editor.updateSlideActiveAction({
          multipleCountAnswer: 0,
        })
        editor.$store.state.tempAudienceCount = 0
      }
      editor.$store.state.tempAudienceCount++
      this._handleAudienceScaleQuestionThrottled()
      this.updateVoteCountForScaleThrottle(editor)
    }

    if (doc.type === 'opentok') {
      if (doc.action === 'stop-call') {
        if (editor.$store.state.voiceCall.audienceUnique === doc.data.audienceUnique) {
          EventBus.$emit('stop-video-call')
        }
      }
    }
  },

  _handleUserOnlineCount(editor, socketData) {
    const doc = {
      data: {
        audience: socketData.data.a,
        audienceName: socketData.data.n,
        audienceEmoji: socketData.data.e,
        quizOnline: socketData.data.q,
        audienceTeam: socketData.data.t,
      },
    }
    if (socketData.i) {
      doc.data.data = {
        id: socketData.data.i,
        answer: socketData.data.r,
      }
    }

    const params = {
      audience: doc.data.audience,
      audienceEmoji: doc.data.audienceEmoji,
      audienceName: doc.data.audienceName,
      offline: doc.data.offline,
      audienceTeam: doc.data.audienceTeam,
    }

    const objAudience = editor.$store.state.audiences[params.audience]
    if (!objAudience) {
      editor.$store.state.audiences[params.audience] = params
    } else {
      if (objAudience.audienceName !== params.audienceName) {
        editor.$store.state.audiences[params.audience].audienceName = params.audienceName
      }
      if (objAudience.audienceEmoji !== params.audienceEmoji) {
        editor.$store.state.audiences[params.audience].audienceEmoji = params.audienceEmoji
      }
      if (objAudience.audienceTeam !== params.audienceTeam) {
        editor.$store.state.audiences[params.audience].audienceTeam = params.audienceTeam
      }
      if (objAudience.offline !== params.offline) {
        editor.$store.state.audiences[params.audience].offline = params.offline
      }

      if (doc.data.data) {
        if (
          editor.$store.state.audiences[params.audience][doc.data.data.id] !== true
        ) {
          editor.$store.state.audiences[params.audience][doc.data.data.id] = doc.data.data.answer
        }
      }
    }

    if (editor.isQuizLobbyScreen || editor.isQuizResultScreen || editor.slideActive.type === 'qrcode') {
      editor._getAudienceOnlineJoinQuiz()
      if (editor.$store.state.presentation.teamPlay) {
        editor._getAndSetPayloadAudienceTeamName(params)
      }
      editor.audienceChangeStatusAction(params)
    }
    if (editor.$store.state.slideActive.type === 'spinnerWheel' && editor.$store.state.slideActive.wheelStatus !== 'spinning') {
      editor._handleEventAudienceOnOff()
    }
  },

  _handleAudienceScaleQuestionThrottled: _.throttle(() => {
    EventBus.$emit('scaleQuestionAnswer')
  }, 1000),

  updateVoteCountForScaleThrottle: _.throttle((editor) => {
    editor.updateSlideActiveAction({
      multipleCountAnswer: editor.$store.state.tempAudienceCount,
    })
  }, 250),

  _updateQuestionAnswer(editor, question) {
    const index = editor.$store.state.questions.findIndex((item) => {
      return item.id == question.id
    })
    if (index === -1) {
      editor.$store.state.questions.push(question)
    } else {
      editor.$store.state.questions[index] = question
    }
    const arr = JSON.parse(JSON.stringify(editor.$store.state.questions))
    Utils.updateDataQuestionAnswer(arr, editor.$store.state.tabQnaQuestion)
  },

  _handleChangeQuizTeam(editor, data) {
    if (editor.$store.state.audiences[data.a]) {
      delete editor.$store.state.audiences[data.a]
    }
  },

  _handleOnlineCountThrottled: _.throttle((editor) => {
    editor.$store.state.userOnline = editor.onlineCount

    if (editor.$store.state.currentUser.id) {
      if (!editor.$store.state.sharePresentation) {
        const percentLimit =
          (editor.$store.state.userOnline / editor.$store.state.plan.limit) *
          100
        if (percentLimit > 75 && percentLimit < 95) {
          editor.$store.state.onlineStatus = 2
        }
        if (percentLimit >= 95) {
          editor.$store.state.onlineStatus = 3
        }
        if (percentLimit <= 75 && editor.$store.state.onlineStatus != 1) {
          editor.$store.state.onlineStatus = 1
        }
      } else {
        editor.$store.state.onlineStatus = 1
      }

      mixpanelUtils.trackHostingEvent({
        presentation: editor.presentation,
        onlineCount: editor.onlineCount,
        maxOnlineCount: editor.maxOnlineCount,
      })
    }
  }, 1000),

  updateVoteCountThrottle: _.throttle((editor, doc, index) => {
    const { s: slideId } = doc
    const payload = {
      id: slideId,
      multipleCountAnswer: editor.$store.state.tempAudienceCount,
    }

    if (index !== null) {
      payload.multipleCountAnswer = editor.presentation.slides[index].voteCache
    }

    editor.patchSlideByIdAction(payload)
  }, 250),

  _updateSlideOptions(editor, doc) {
    const { s: slideId, v: votedSlideOptionIds } = doc

    const matchSlide = editor.presentation.slides.find((slide) => slide.id === slideId)
    if (!matchSlide) return

    const newSlideOptions = matchSlide.SlideOptions.map((slideOption) => {
      const hasVoted = votedSlideOptionIds.some((item) => item === slideOption.id)

      if (hasVoted) {
        const currentCount = slideOption.count || 0
        return {
          ...slideOption,
          count: currentCount + 1,
        }
      }

      return slideOption
    })

    editor.patchSlideByIdAction({
      id: slideId,
      SlideOptions: newSlideOptions,
    })
  },

  _checkEveryoneVotedQuiz(editor) {
    if (editor.$store.state.slideActive.type !== 'pickAnswer') {
      return
    }
    if (editor.$store.state.slideActive.quizStatus !== Constants.QuizStatuses.QUESTION_SCREEN) {
      return
    }

    let someoneHaveNotVote = false

    Object.keys(editor.$store.state.audiences).forEach((key) => {
      const audience = editor.$store.state.audiences[key]
      const audienceNotAnswer = !audience[editor.$store.state.slideActive.id]
      if (audienceNotAnswer) {
        someoneHaveNotVote = true
      }
    })
    if (!someoneHaveNotVote) {
      EventBus.$emit('everyone-voted')
    }
  },

  disconnectSocket(editor) {
    socketHelper.leaveRoomPresentation(editor.presentation.uniqueAccessCode)
    socketHelper.leaveRoomSlide(editor.presentation.uniqueAccessCode, editor.slideActive.id)

    Socket.getSocket().off('socket:online')
    Socket.getSocket().off('socket:offline')
    Socket.getSocket().off('presenter-takeover')
    Socket.getSocket().off('create-idea')
    Socket.getSocket().off('vote-idea')
    Socket.getSocket().off('presenter-removed')
    Socket.getSocket().io.off('reconnect')
    Socket.getSocket().off('add-slides')
    Socket.getSocket().off('presentation:report_generated')
    Socket.getSocket().off('backstage-control')
    Socket.off(CREATE_REACTION)
    Socket.off('patch-presentation')
    Socket.getSocket().off('collab-updated')

    Socket.unSubscribe(editor.$store.state.presentation.uniqueAccessCode)
    Socket.unSubscribe(`${editor.$store.state.presentation.uniqueAccessCode}-presenter`)
    Socket.unSubscribe(`user-${editor.$store.state.currentUser.id}`)
  },

  handleSocketEvent(editor) {
    Socket.getSocket().io.on('reconnect', () => this._handleOnReconnect(editor))

    Socket.getSocket().on('socket:online', (doc) => this._handleSocketOnline(editor, doc))
    Socket.getSocket().on('socket:offline', (doc) => this._handleSocketOffline(editor, doc))
    Socket.getSocket().on('presenter-takeover', (doc) => this._handleTakeOverEvent(editor, doc))
    Socket.getSocket().on('create-idea', (doc) => this._handleAudienceCreateIdeaEvent(editor, doc))
    Socket.getSocket().on('vote-idea', (doc) => this._handleAudienceVoteIdeaEvent(editor, doc))
    Socket.getSocket().on('presenter-removed', (doc) => this._handleRemovePresenterEvent(editor, doc))
    Socket.getSocket().on('add-slides', (doc) => this._handleAddSlides(editor, doc))
    Socket.getSocket().on('presentation:report_generated', (doc) => this._handleUpdateReport(editor, doc))
    Socket.getSocket().on('backstage-control', (doc) => this._handleBackstageControl(editor, doc))
    Socket.getSocket().on('collab-updated', (doc) => this._handleCollabUpdate(editor, doc))
    Socket.on(CREATE_REACTION, (doc) => this._handleCreateReaction(editor, doc))
    Socket.on('patch-presentation', (doc) => this._handlePatchPresentation(editor, doc))
  },

  trackingJoinPresentation: _.debounce((presenter, presentation, sockets) => {
    const arrKeySocketIds = Object.keys(sockets)
    if (arrKeySocketIds.length <= 0) {
      return
    }

    const userSockets = {}
    let countEditor = 0
    let countViewer = 0
    arrKeySocketIds.forEach((socketId) => {
      const userInfo = sockets[socketId]
      if (!userSockets[userInfo.id]) {
        userSockets[userInfo.id] = {
          ...userInfo,
          socketId,
        }
        if (userInfo.accountRole === workspace.VIEWER) {
          countViewer++
        } else {
          countEditor++
        }
      }
    })

    const keyStorage = `collab-user-count-${presentation.id}`
    const countUser = Object.keys(userSockets).length
    const oldCountUserCollab = storage.getValue(keyStorage, 0)
    if (oldCountUserCollab >= countUser || countUser <= 1) {
      return
    }
    storage.setValue(keyStorage, countUser)
    Utils.ga4Track('Join co-editing session', {
      eventAction: 'Join co-editing session',
      presentationId: presentation.id,
      teamId: presentation.accountId,
      editorCount: countEditor,
      viewerCount: countViewer,
    })
  }, 3000),

  _handleSocketOnline(editor, doc) {
    this.trackingJoinPresentation(doc.presenter, editor.presentation, JSON.parse(JSON.stringify(editor.sockets)))
    if (!editor.sockets[doc.socketId] || !editor.sockets[doc.socketId].id) {
      editor.sockets[doc.socketId] = doc.presenter
      editor.joinCollaborativeEditingRoom(editor.presentation)
    }
    this.refreshEditor(editor)
    if (doc.socketId === Socket.getSocketId()) {
      CollabHelpler.getListUsersEditPresentation()
    }
  },

  _handleSocketOffline(editor, doc) {
    // Skip on shared screen
    if (editor.$route.name === 'PresentationShare') return

    delete editor.sockets[doc.socketId]
    this.refreshEditor(editor)
    CollabHelpler.getListUsersEditPresentation()
  },

  refreshEditor(editor) {
    const presenters = []
    Object.keys(editor.sockets).forEach((k) => {
      const socket = editor.sockets[k]
      const idx = presenters.findIndex((p) => { return p.id === socket.id })
      if (idx === -1) {
        socket.isMyData = socket.id == editor.currentUser.id
        if (socket.id == editor.currentUser.id && editor.isGuestUser) {
          // Demo mode, show you as Guest
          socket.name = 'Guest'
        }
        presenters.push(socket)
      }
    })

    presenters.sort((a, b) => {
      if (editor.presentation.takenOverBy === a.id) return -1
      if (editor.presentation.takenOverBy === b.id) return 1
      if (a.id < b.id) return -1
      if (a.id > b.id) return 1
      return 0
    })

    editor.$store.state.presentationEditors = presenters
    if (editor.presentation.takenOverBy) {
      editor.$store.state.isDisableEditPresentation =
      editor.presentation.takenOverBy && editor.currentUser.id !== editor.presentation.takenOverBy
    }
  },

  _handleBackstageControl(editor, payload) {
    const { socketId, type, data } = payload
    if (socketId === Socket.getSocketId()) return
    // Only update for other screens
    if (type === 'update-slide-active') {
      editor.updateSlideActiveAction(data)
      if (data.quizStatus === 5 || data.showCorrectOption) {
        editor._handleShowResultsOnQuizSlide()
      }
    } else if (type === 'start-quiz-on-other-screen') {
      EventBus.$emit('start-quiz-on-other-screen', data)
    } else if (type === 'reload') {
      // Backstage: Whenever reload quiz on origin screen
      // -> set quiz scene to Lobby on other screens
      if (editor.slideActive.type === 'pickAnswer') {
        const updatedSlide = {
          quizStatus: Constants.QuizStatuses.LOBBY_SCREEN,
        }
        editor.updateSlideActiveAction(updatedSlide)
        updatedSlide.socketId = Socket.getSocketId()
        updatedSlide.accessCode = editor.$store.state.presentation.uniqueAccessCode
        updatedSlide.presentationId = editor.$store.state.presentation.id
        // if
        // updatedSlide.presenting = editor.$store.getters.isPresenting || editor.isBackstage
        editor.$http
          .put(Config.api.updateSlide + editor.$store.state.slideActive.id, updatedSlide)
          .then(() => {
          }, () => {})
      }
    } else if (type === 'acceptTypeAnswer') {
      EventBus.$emit('accept-other-type-answers-from-backstage')
    }
  },

  async _handleTakeOverEvent(editor, doc) {
    if (editor.currentUser.id === editor.presentation.takenOverBy &&
      doc.takenOverBy !== editor.currentUser.id) {
      Object.keys(editor.sockets).forEach((k) => {
        const socket = editor.sockets[k]

        if (doc.takenOverBy === socket.id) {
          editor.tookOverPresenter = socket
          editor.presentation.TakenOverByUser = socket
        }
      })

      if (!editor.isMSTeamsApp) {
        EventBus.$emit('clearOtherPopups')
        setTimeout(() => {
          editor.isShowBeTakenOverModal = true
        }, 300)
      }
    }

    editor.presentation.takenOverBy = doc.takenOverBy

    this.refreshEditor(editor)

    // AHA-5372 Presenting > Khi đang presenting và bị take over, presenter đó chưa được chuyển về màn hình Editor
    if (doc.takenOverBy != editor.currentUser.id) {
      if (editor.isMSTeamsApp) {
        editor.isShowMSTeamsReloadModal = true
        return
      }
      editor.$store.dispatch(SET_CURRENT_SLIDE_MODE, EDIT_MODE)
      editor.$router.replace({
        name: 'PresentationDetail',
        params: {
          id: editor.$store.state.presentation.id,
          beTakenOver: true,
        },
      })
    } else {
      await editor.getDataPresentationDetail({ cachedContentSlides: false })

      // This is a hack. We should not doeditor.
      const currentSlideId = editor.$store.state.slideActive.id
      if (currentSlideId) {
        editor.$store.dispatch('updateSlideActive', {
          activeTab: null,
          id: null,
        })
        setTimeout(() => {
          editor.$store.dispatch(SET_CURRENT_ACTIVE_SLIDE, currentSlideId)
          EventBus.$emit('eventHandleSetValueTransition')
        }, 0)
      }
    }
  },

  _handleAudienceCreateIdeaEvent(editor, doc) {
    editor._checkAndUpdateHasResults()
    const matchSlide = editor.presentation.slides.find((slide) => slide.id === doc.slideId)

    if (!matchSlide
      || !matchSlide.SlideOptions
      || matchSlide.SlideOptions.length >= Constants.MAX_IDEAS_NUMBER) {
      return
    }

    let newSlideOptions = [...editor.slideActive.SlideOptions, doc]
    newSlideOptions = newSlideOptions
      .map((idea, index) => ({ ...idea, createdAtOrder: index + 1 }))

    editor.patchSlideByIdAction({
      id: doc.slideId,
      SlideOptions: newSlideOptions,
    })

    if (doc.slideId === editor.slideActive.id) {
      EventBus.$emit('handleSortIdeasByCreatedAt')
    }

    EventBus.$emit('handleScrollingAndShowScroll')
  },

  _handleAudienceVoteIdeaEvent: _.throttle((editor, doc) => {
    const index = editor.slideActive.SlideOptions.findIndex((option) => {
      return option.id === doc.slideOptionId
    })
    if (index === -1) return
    editor.slideActive.SlideOptions[index].votesCount = doc.numberOfVotes
    editor.updateSlideActiveAction(editor.slideActive)
  }, 300),

  _handleRemovePresenterEvent(editor, doc) {
    const { removedPresenters } = doc
    if (removedPresenters.indexOf(editor.currentUser.email) > -1) {
      Utils.showToastError('You have been removed from this presentation')
      window.setTimeout(() => {
        window.location.reload()
      }, 2000)
    }
  },

  _handleAddSlides(editor, payload) {
    const slideTypes = {}
    Constants.allTypeSections.forEach((item) => {
      item.slideTypes.forEach((typeObj) => {
        slideTypes[typeObj.type] = typeObj
      })
    })

    payload.slides.forEach((item) => {
      if (item.type) {
        item.typeObj = slideTypes[item.type]
      }
    })

    editor.$store.state.presentation.slides = editor.$store.state.presentation.slides.concat(
      payload.slides,
    )
  },

  async _handleOnReconnect(editor) {
    editor.sockets = {}
    await editor.getDataPresentationDetail()
    editor.joinCollaborativeEditingRoom(editor.presentation)
  },

  _handleUpdateReport(editor, payload) {
    editor.patchPresentationAction({
      exportData: {
        ...editor.presentation.exportData,
        ...payload,
      },
    })
  },

  _handleCreateReaction: _.throttle((editor, message) => {
    const { audienceName, reactionType, ...partialPresentation } = message
    editor.patchPresentationAction(partialPresentation)
    editor._checkAndUpdateHasResults()
    EventBus.$emit(CREATE_REACTION, { audienceName, reactionType })
  }, 200),

  _handlePatchPresentation(editor, payload) {
    // Reactions already set state, set again will results in flickering
    // https://ahaslides.atlassian.net/browse/AHA-7788
    if (payload.reactions) return
    editor.patchPresentationAction(payload)
  },

  addNewSlide(slide, slides) {
    store.state.presentation.slides.push(slide)
    this.sortOrderSlides(slides)
  },

  sortOrderSlides(slides) {
    if (slides) {
      store.state.presentation.slides.forEach((item) => {
        const index = slides.findIndex((slide) => {
          return slide.id === item.id
        })
        if (index !== -1) {
          item.order = slides[index].order
        }
      })
      store.state.presentation.slides.sort((a, b) => {
        return a.order - b.order
      })
      store.state.presentation.slides.push()
    }
    CollabHelpler.getListUsersEditPresentation()
  },

  async handleContentSlideUpdate(slide, editor) {
    RenderCanvasUtil.updateCanvasBlockForSlideActive(editor, store.state.presentation.slides, {
      cachedContentSlides: false,
    })
  },

  async getDataSlide(slideId, editor) {
    const resp = await SlideApi.getSlideById(slideId)
    if (resp.body.data.canvasBlocksUrl && editor) {
      const contentData = await editor.$http.get(resp.body.data.canvasBlocksUrl)
      resp.body.data.canvasBlocks = contentData.body
    }
    return resp.body.data
  },

  async _handleCollabUpdate(editor, doc) {
    if (doc.type === 'sort-slide' && doc.data.socketId !== Socket.getSocketId()) {
      this.sortOrderSlides(doc.data.slides)
    }
    if (doc.type === 'clear-result' && doc.data.socketId !== Socket.getSocketId()) {
      const resp = await SlideApi.listSlidesDetail(
        { ids: doc.data.slideIds.toString(), presentationId: store.state.presentation.id },
      )
      const slides = resp.data.filter((item) => item.type !== 'freeStyle')
      slides.forEach((slide) => {
        const index = store.state.presentation.slides.findIndex(
          (item) => item.id === slide.id,
        )
        if (index !== -1) {
          store.state.presentation.slides[index] = {
            ...store.state.presentation.slides[index], ...slide,
          }
          if (slide.id === store.state.slideActive.id) {
            store.dispatch('updateSlideActiveAction', store.state.presentation.slides[index])
          }
        }
      })

      if (doc.data.isClearAll) {
        store.state.questions = []
        store.state.tabQnaQuestion = 1
        store.state.lastQuestion = {}
        store.state.questionCount = 0
      }
      CollabHelpler.getListUsersEditPresentation()
    }
    if (doc.type === 'presenterLeave' && doc.data.socketId !== Socket.getSocketId()) {
      CollabHelpler.getListUsersEditPresentation()
    }
    if (doc.type === 'duplicate-slides' && doc.data.socketId !== Socket.getSocketId()) {
      const { newSlides } = doc.data
      newSlides.forEach((item) => {
        store.state.presentation.slides.push(item)
      })
      store.state.presentation.slides.sort((a, b) => {
        return a.order - b.order
      })
      store.state.presentation.slides.push()
    }
    if (doc.type === 'next-slide') {
      CollabHelpler.getListUsersEditPresentation()
    }
    if (doc.type === 'create-new-slide' && doc.data.socketId !== Socket.getSocketId()) {
      const slide = await this.getDataSlide(doc.data.slideId, editor)
      this.addNewSlide(slide, doc.data.slides)
    }
    if (doc.type === 'after-deleted') {
      CollabHelpler.getListUsersEditPresentation()
    }
    if (doc.type === 'slide-updated' && doc.data.socketId !== Socket.getSocketId()) {
      if (!doc.data.deleted) {
        const slide = await this.getDataSlide(doc.data.slideId, editor)
        const index = store.state.presentation.slides.findIndex((item) => item.id === slide.id)
        if (index !== -1) {
          slide.usersOnline = store.state.presentation.slides[index].usersOnline
          if (slide.id === store.state.slideActive.id) {
            const sortOptions = slide.SlideOptions.sort((slideA, slideB) => {
              return slideA.order - slideB.order
            })
            slide.SlideOptions = sortOptions
            store.dispatch('updateSlideActiveAction', slide)
            if (slide.type === 'freestyle') {
              this.handleContentSlideUpdate(slide, editor)
            }
            EventBus.$emit('slide-update-timelimit')
            EventBus.$emit('updateTitleDesc')
          } else {
            store.state.presentation.slides[index] = slide
            store.state.presentation.slides.push()
          }
        } else {
          this.addNewSlide(slide)
        }
      } else {
        const index = store.state.presentation.slides.findIndex(
          (item) => item.id === parseInt(doc.data.slideId, 10),
        )
        if (index !== -1) {
          store.state.presentation.slides.splice(index, 1)
          if (doc.data.slideId === store.state.slideActive.id) {
            store.dispatch('updateSlideActiveAction', store.state.presentation.slides[index - 1])
          }
        }
      }
    }
    if (doc.type === 'multiple-slide-updated') {
      const resp = await SlideApi.getSlideById(doc.data[0].id)
      const dataSlide = resp.body.data
      doc.data.forEach((slide) => {
        const payload = {
          backgroundImage: dataSlide.backgroundImage,
          backgroundImageCropperData: dataSlide.backgroundImageCropperData,
          backgroundSize: dataSlide.backgroundSize,
          baseColour: dataSlide.baseColour,
          originBackgroundImage: dataSlide.originBackgroundImage,
          textColour: dataSlide.textColour,
          visibility: dataSlide.visibility,
        }
        const index = store.state.presentation.slides.findIndex((item) => item.id === slide.id)
        if (index !== -1) {
          store.state.presentation.slides[index] =
            { ...store.state.presentation.slides[index], ...payload }
          if (slide.id === store.state.slideActive.id) {
            store.dispatch('updateSlideActiveAction', payload)
            EventBus.$emit('eventHandleSetValueTransition')
          }
        }
      })
      store.state.presentation.slides.push()
    }

    if (doc.type === 'import-document' && doc.data.socketId !== Socket.getSocketId()) {
      // const slides = await SlideApi.listSlidesDetail(
      //   { ids: doc.data.slides.map((item) => item.id) },
      // )
      // slides.forEach((item) => {
      //   const index = store.state.presentation.slides.findIndex((s) => s.id === item.id)
      //   if (index !== -1) {
      //     store.state.presentation.slides[index].order = item.order
      //   } else {
      //     store.state.presentation.slides.push(item)
      //   }
      // })
      // store.state.presentation.slides.sort((a, b) => {
      //   return a.order - b.order
      // })
      // store.state.presentation.slides.push()
      CollabHelpler.getListUsersEditPresentation()
    }
    if (doc.type === 'change-access-code' && doc.data.socketId !== Socket.getSocketId()) {
      store.state.presentation.accessCode = doc.data.newAccessCode
      EventBus.$emit('update-access-code', doc.data.newAccessCode)
    }
  },
}
